import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgPipesModule } from 'ngx-pipes'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'

import { EntityListModule } from 'common/entityList'
import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'
import { MediaCustomFieldsModule } from 'media.customFields'

import { JobVariablesInputComponent } from './components/jobVariablesInput.component'
import { StartJobModalComponent } from './components/startJobModal.component'
import { TaskInputComponent } from './components/taskInput.component'
import { TasksPopupComponent } from './components/tasksPopup.component'
import { TaskStateBadgeComponent } from './components/taskStateBadge.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([]),
    NgbDropdownModule,
    NgPipesModule,
    UtilCommonModule,
    EntityListModule,
    MediaCustomFieldsModule,
    LocaleModule.forChild(),
  ],
  declarations: [
    JobVariablesInputComponent,
    StartJobModalComponent,
    TaskStateBadgeComponent,
    TaskInputComponent,
    TasksPopupComponent,
  ],
  exports: [
    JobVariablesInputComponent,
    StartJobModalComponent,
    TaskStateBadgeComponent,
    TaskInputComponent,
    TasksPopupComponent,
  ],
})
export class TasksModule { }

export { TaskState, TasksService } from './services/tasks.service'
export { StartJobModalComponent }
